import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import SearchSvg from '../../svg/admin/Search';
import MoreSvg from '../../svg/admin/More';
import PageSelector from '../components/PageSelector';
import { useSetting } from '../../util/useSetting';



function Component(props) {
    const { } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const id = searchParams.get('id');
    const [data, setdata] = useState(null)
    const [isLoading, setisLoading] = useState(false)
    const [total, settotal] = useState(0)
    const { fontSize } = useSetting();


    const filter = searchParams.get('filter') || '全部';
    const status = searchParams.get('status') || '全部';
    const page = parseInt(searchParams.get('page')) || 1;
    const limit = 10
    const totalPage = Math.ceil(total / limit) || 1

    const handleSelectPage = (p) => async () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    const handleUpdateStatus = (newValue) => {
        searchParams.delete('status')
        searchParams.set('status', newValue)
        setSearchParams(searchParams)
    }

    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)

        setisLoading(false)
    }



    useEffect(() => {
        const timer = setTimeout(fetchData, 500)
        // const interval = setInterval(fetchData,1000*30)
        return () => {
            clearTimeout(timer)
            // clearInterval(interval)
        }
    }, [searchParams])



    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex p-[16px] gap-[16px] overflow-auto' style={{ fontSize, backgroundImage: 'url(/secondary/bg9.png)', backgroundSize: 'cover', backgroundPosition: 'right', backgroundRepeat: 'no-repeat' }}>
            {/*title, filter, serach box*/}
            <div className='p-[16px] flex flex-col items-start justify-start gap-[16px]'>
                <div className='text-[#4B555C] font-[900] ' style={{ fontSize: fontSize + 4 }}>我的成就</div>
            </div>
            {/*end of title, filter, serach box*/}

            <div className='flex flex-col justify-start w-[100%] z-[2] mt-[48px]'>
                <div className='text-[#003A57] font-[900] w-full flex flex-col items-center' style={{ border: '2px solid white', borderRadius: '8px', backdropFilter: 'blur(8px)' }}>
                    <div className='w-full text-center p-[8px]' style={{ borderBottom: '2px solid white', borderRadius: '8px', fontSize: fontSize + 4 }}>已達成</div>
                    <div className='p-[16px] font-[700] noto-san-hk text-black  w-full flex flex-row flex-wrap gap-[32px]' style={{ textAlign: 'justify' }}>
                        {[1,2,3,4,5]?.map((item, index) => (
                            <div key={index} className='flex flex-col relative pl-[30px] gap-[4px]'>
                                <div className='text-white font-[700] pl-[70px] pr-[64px] py-[8px] rounded-full text-left' style={{background:'linear-gradient(90deg, #178E95, #07162F)'}}>閱讀大師</div>
                                <div className='text-[#1D1D41] font-[300] w-full text-left pl-[70px] pr-[64px]' style={{fontSize: fontSize-2}}>總共 50 次練習<br/>3 次得分至少 80 分</div>
                                <img src='/secondary/a1.png' className='absolute left-[0px] top-[0px] w-[85px] h-[85px] rounded-full' style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'}} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className='flex flex-col justify-start w-[100%] z-[2] mt-[48px]'>
                <div className='text-[#003A57] font-[900] w-full flex flex-col items-center' style={{ border: '2px solid white', borderRadius: '8px', backdropFilter: 'blur(8px)' }}>
                    <div className='w-full text-center p-[8px]' style={{ borderBottom: '2px solid white', borderRadius: '8px', fontSize: fontSize + 4 }}>下一個成就</div>
                    <div className='p-[16px] font-[700] noto-san-hk text-black  w-full flex flex-row flex-wrap gap-[32px]' style={{ textAlign: 'justify' }}>
                        {[1,2,3,4,5,6,7,8,9,10]?.map((item, index) => (
                            <div key={index} className='flex flex-col relative gap-[4px]'>
                                <div className='text-white font-[700] pl-[100px] pr-[80px] mx-[8px] py-[8px] rounded-full text-left relative flex flex-row items-center' style={{background:'linear-gradient(90deg, #34778C, #63BBD1)'}}>
                                    閱讀大師
                                    <img src='/secondary/a1.png' className='absolute left-[0px] w-[70px] h-[70px] rounded-full' style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'}} />
                                </div>
                                <div className='text-[#1D1D41] font-[400] w-full text-left bg-[white] flex flex-col rounded-[16px] p-[16px] pt-[32px] mt-[-8px] gap-[8px]' style={{fontSize: fontSize, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'}}>
                                    <div>總共 50 次練習 (45/50)</div>
                                    <div className='h-[4px] w-full bg-[#d1d1d1] flex flex-row justify-start'>
                                        <div className='h-[4px] bg-[#80DC91] rounded-full' style={{width: `${(45/50)*100}%`}}/>
                                    </div>

                                    <div className='mt-[16px]'>3 次得分至少 80 分 (2/3)</div>
                                     <div className='h-[4px] w-full bg-[#d1d1d1] flex flex-row justify-start'>
                                        <div className='h-[4px] bg-[#80DC91] rounded-full' style={{width: `${(2/3)*100}%`}}/>
                                    </div>
                                </div>
                                
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
